import i18n from 'i18next';
// import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';

import { changeLanguage } from 'actions/i18n';

import resources from './resources';

export const lanList = ['zh-TW', 'zh-CN', 'en', 'ja', 'ko'];

export const LANG_MAP = {
	tw: 'zh-TW',
	cn: 'zh-CN',
	en: 'en',
	jp: 'ja',
	kr: 'ko',
};

export const lanData = {
	'zh-TW': {
		id: 0,
		label: '繁',
		value: 'tw',
		bookingCode: '',
		locale: 'zh-TW',
	},
	ja: {
		id: 1,
		label: '日',
		value: 'jp',
		bookingCode: 2,
		locale: 'ja-JP',
	},
	ko: {
		id: 2,
		label: '한',
		value: 'kr',
		bookingCode: 12,
		locale: 'ko-KR',
	},
	en: {
		id: 3,
		label: 'EN',
		value: 'en',
		bookingCode: 1,
		locale: 'en-US',
	},
	'zh-CN': {
		id: 4,
		label: '简',
		value: 'cn',
		bookingCode: 11,
		locale: 'zh-CN',
	},
};

const languageDetect = {
	name: 'urlDetect',

	lookup() {
		let found;

		if (typeof window !== 'undefined') {
			const pathnames = window.location.pathname.split('/');

			if (pathnames.length >= 3 && pathnames[2] !== 'main') {
				if (pathnames[2] in LANG_MAP) {
					found = LANG_MAP[pathnames[2]];
				} else {
					found = 'zh-TW';
				}
			}
		}

		return found;
	},
};

export const initi18next = store => {
	const lngDetector = new LanguageDetector();
	// Setup Custom detector;
	lngDetector.addDetector(languageDetect);

	i18n
		// .use(Backend)
		.use(lngDetector)
		.use(reactI18nextModule)
		.init(
			{
				fallbackLng: 'zh-TW',

				whitelist: lanList,

				// have a common namespace used around the full app
				ns: ['navigators', 'translations'],
				defaultNS: 'translations',

				debug: process.env.NODE_ENV !== 'production',

				interpolation: {
					escapeValue: false, // not needed for react!!
				},

				// Open when use backend
				// saveMissing: true,

				react: {
					wait: true,
				},

				detection: {
					order: ['urlDetect', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
				},

				// Fakes translations resources. If you want to use backend, turn off this.
				resources,
			},
			() => {
				store.dispatch(changeLanguage(i18n.language));
			},
		);

	i18n.on('languageChanged', () => {
		store.dispatch(changeLanguage(i18n.language));
	});

	return i18n;
};

export const lanMapRoute = lan => {
	const language = lan.split('-');
	if (language[0] === 'ja' || lan === 'jp') {
		return 'jp';
	}

	if (language[0] === 'ko' || lan === 'kr') {
		return 'kr';
	}

	if (lan === 'zh-CN' || lan === 'cn') {
		return 'cn';
	}

	if (lan === 'zh-TW' || lan === 'tw') {
		return 'tw';
	}

	if (['en'].includes(language[0]) || lan === 'en') {
		return language[0];
	}

	// Default router;
	return 'tw';
};

const routeMapLan = route => {
	if (route in LANG_MAP) {
		return LANG_MAP[route];
	}

	// Default router;
	return 'zh-TW';
};

export const changeLng = lng => i18n.changeLanguage(routeMapLan(lng));

export const translate = lan => translateGroup => key => resources[lan][translateGroup][key] || key;



// WEBPACK FOOTER //
// ./src/util/i18n.js